import type { ViewInput } from '@lib/types';
import { formatNumber } from '@akashrajpurohit/utils';
import { createResource, Suspense } from 'solid-js';

const getViewCount = async (params: ViewInput): Promise<number> => {
	try {
		const response = await fetch('/api/views', {
			method: 'POST',
			body: JSON.stringify(params),
			headers: {
				'Content-Type': 'application/json',
			},
		});
		const data = (await response.json()) as { totalViews: number };

		return data.totalViews;
	} catch (err) {
		return 0;
	}
};

type Props = ViewInput;

export default function ViewCount({ slug, type }: Props) {
	const [totalViews] = createResource({ slug, type }, getViewCount);

	return (
		<Suspense
			fallback={
				<span
					role="status"
					class="animate-pulse mt-1.5 h-3 bg-gray-200 rounded-md dark:bg-gray-700 w-10"
				/>
			}
		>
			<span>👀 {formatNumber(totalViews() || 0)}</span>
		</Suspense>
	);
}
